import { DEFAULT_CURRENCY } from '@constants/currency';

import type {
  ICustomerStructure,
  IFacilityStructureNode,
  ILocation,
  ILocationStructureNode,
} from '@model/structureData';

export const getCustomerStructureTree = (
  locations: ILocation[],
  pathsById: Record<number, string>,
): ICustomerStructure => {
  const structure: ICustomerStructure = {
    locations: [],
    locationsIds: [],
    facilities: [],
    facilitiesIds: [],
  };

  if (!Array.isArray(locations) || locations.length === 0) return structure;

  structure.facilities = buildFacilityTree(locations, pathsById, structure);

  return structure;
};

const buildFacilityTree = (
  nodes: ILocation[],
  pathsById: Record<number, string>,
  structure: ICustomerStructure,
  parentNode: ILocationStructureNode | null = null,
): IFacilityStructureNode[] => {
  return nodes.map((node) => {
    const facilityStructureNode: IFacilityStructureNode = {
      ...node,
      isDisabled: node.disabled,
      disabled: false,
      children: [],
      noTreeTitle: null,
      parentsIds: parentNode ? [parentNode.id, ...parentNode.parentsIds] : [],
    };

    const locationStructureNode: ILocationStructureNode = {
      ...facilityStructureNode,
      repeats: 2 * (node.level - 1),
      parentId: parentNode?.id,
      path: pathsById[node.id],
      facility: node.facility,
      facilityName: node.facility?.name,
      status_type: node.facility?.status_type,
      parents: parentNode ? [parentNode] : [],
      children: !!node.children?.length,
      currency: node.facility?.currency || DEFAULT_CURRENCY,
    };

    structure.locations.push(locationStructureNode);
    structure.locationsIds.push(locationStructureNode.id);

    if (node.levelName === 'facility') {
      structure.facilitiesIds.push(node.id);
    }

    if (node.children.length) {
      facilityStructureNode.children = buildFacilityTree(
        node.children,
        pathsById,
        structure,
        locationStructureNode,
      );
    }

    return facilityStructureNode;
  });
};
